import {CalculationStatus} from "../../../_snowpack/link/dist/@salaxy/core/salaxy-lib-core.js";
export class CalculationsNaviProController {
  constructor(cacheService, proService) {
    this.cacheService = cacheService;
    this.proService = proService;
    this._entryItemInProgress = false;
  }
  get proList() {
    if (this.category === "paid") {
      const odata = this.cacheService.getFullCache("pro-calc-paid").data || {};
      return odata.items || [];
    } else if (this.category === "draft") {
      const odata = this.cacheService.getFullCache("pro-calc-draft").data || {};
      return odata.items || [];
    } else {
      return [];
    }
  }
  get currentCalcIndex() {
    return this.proList.findIndex((x) => x.id === this.idFromPath);
  }
  get currentCalc() {
    if (this.currentCalcIndex === -1) {
      return null;
    }
    return this.proList[this.currentCalcIndex];
  }
  get previousCalc() {
    if (this.currentCalcIndex === -1 || this.currentCalcIndex === 0) {
      return null;
    }
    return this.proList[this.currentCalcIndex - 1];
  }
  get nextCalc() {
    if (this.currentCalcIndex === -1 || this.currentCalcIndex === this.proList.length - 1) {
      return null;
    }
    return this.proList[this.currentCalcIndex + 1];
  }
  get idFromPath() {
    return this.proService.getIdFromPath();
  }
  get category() {
    if (!this._entryItem) {
      if (this.idFromPath && !this._entryItemInProgress) {
        this._entryItemInProgress = true;
        this.proService.getJSON(`pro/calculations/readonly?$filter=id eq '${this.idFromPath}'`).then((data) => {
          if (data.items.length == 1) {
            this._entryItem = data.items[0];
          } else {
            this.proService.getJSON(`pro/calculations/editable?$filter=id eq '${this.idFromPath}'`).then((data2) => {
              if (data2.items.length == 1) {
                this._entryItem = data2.items[0];
              }
            });
          }
        });
      }
      return null;
    } else {
      if (this._entryItem.status === CalculationStatus.PaymentStarted || this._entryItem.status === CalculationStatus.PaymentSucceeded) {
        return "paid";
      } else {
        return "draft";
      }
    }
  }
}
CalculationsNaviProController.$inject = [
  "CacheService",
  "ProService"
];
